/**
 * Componente para seleção de categoria do produto (buttons select)
 */

import React from 'react';
import { ProdutoCategoriaItem } from '../../../../types/gerArquivos';
import { Check } from 'lucide-react';

interface CategoriaSelectorProps {
  categorias: ProdutoCategoriaItem[];
  selected: 1 | 2 | 3 | 4;
  onSelect: (id: 1 | 2 | 3 | 4) => void;
  loading?: boolean;
}

export const CategoriaSelector: React.FC<CategoriaSelectorProps> = ({
  categorias,
  selected,
  onSelect,
  loading = false
}) => {
  if (loading) {
    return (
      <div className="space-y-2">
        <label className="block text-xs text-gray-300 font-medium">
          Categoria do Produto <span className="text-red-400">*</span>
        </label>
        <div className="flex items-center justify-center py-6">
          <div className="w-5 h-5 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className="block text-xs text-gray-300 font-medium">
        Categoria do Produto <span className="text-red-400">*</span>
      </label>
      
      <div className="grid grid-cols-2 gap-2">
        {categorias.map((cat) => {
          const isSelected = cat.id === selected;
          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect(cat.id as 1 | 2 | 3 | 4)}
              className={`
                relative px-2 py-2 rounded-lg border transition-all text-left
                ${
                  isSelected
                    ? 'border-blue-500 bg-blue-500/10 text-blue-100'
                    : 'border-navy-600 bg-navy-800 text-gray-300 hover:border-navy-500 hover:bg-navy-700'
                }
              `}
            >
              <div className="flex items-start justify-between gap-1.5">
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-medium truncate">{cat.prod_tipo_descricao}</div>
                  {cat.prod_cat_codigo && (
                    <div className="text-[10px] text-gray-500 mt-0.5 truncate">
                      Código: {cat.prod_cat_codigo}
                    </div>
                  )}
                </div>
                {isSelected && (
                  <Check className="w-4 h-4 text-blue-400 flex-shrink-0" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

